<form [formGroup]="pairingForm">
  <input type="text" placeholder="level id" formControlName="levelId" />
  <input type="text" placeholder="ladder id" formControlName="ladderId" />
  <button (click)="doitSingles($event)" [disabled]="busy">do it singles</button>
  <button (click)="doitDoubles($event)" [disabled]="busy">do it doubles</button>
</form>

<div *ngIf="busy" style="margin-top: 10px; font-style: italic;">
  Processing...
</div>

<div *ngIf="results.length > 0" style="margin-top: 20px;">
  <p *ngFor="let r of results">{{r}}</p>
</div>